<template>
    <div
        :class="[
      !rightSide ? '' : '',
      rightSide ? '' : ''
    ]"
    >
            <AttachmentData
                v-if="attachments.length"
                v-for="(attachment,idx) in attachments"
                :attachment="attachment" :key="`attachment-${idx}`"
                :meeting="meeting"
            >
                <template v-slot:default="{ sourceIcon, tooltip, typeIcon, title, url }">
                    <div v-if="!rightSide" class="file-badge mb-4" :class="{'w-fit mr-2 mb-2': inline, 'w-fit mb-2': !inline }">
                        <div  class="flex border border-gray-400 rounded-md px-2 bg-white" :class="{'py-2 pl-2 pr-1': inline, 'bg-white': !inline}">
                            <img :src="typeIcon" class="w-4 mr-2" alt="" aria-hidden="true" />
                                <span v-if="rightSide">
                                </span>
                                <span v-else-if="leftSide">
                                    <a v-if="url" :href="url" class="mr-2 block truncate max-w-[180px] md:max-w-[220px]" target="_blank" :aria-label="`${title} (opens in new tab)`">{{ title }}</a>
                                    <span v-else class="mr-2 text-blue block truncate max-w-[180px] md:max-w-[220px]">{{ title }}</span>
                                </span>
                                <span v-else>
                                    <a v-if="url" :href="url" class="mr-2 block truncate max-w-[180px] md:max-w-[400px]" target="_blank" :aria-label="`${title} (opens in new tab)`">{{ title }}</a>
                                    <span v-else class="mr-2 text-blue block truncate max-w-[180px] md:max-w-[400px]">{{ title }}</span>
                                </span>
                            <button
                                v-if="removable"
                                class="ml-auto btn btn-icon btn-sm w-4 h-4 hover:!bg-gray-400"
                                @click.prevent="removeItem(attachment)"
                            >
                                <font-awesome :icon="['fas', 'xmark']" class="ml-2" />
                            </button>
                        </div>
                    </div>
                </template>
            </AttachmentData>
    </div>
</template>

<script>
import AttachmentData from "~/components/agenda/AttachmentData.vue";

export default {
    name: "AttachmentsList",
    components: { AttachmentData },
    props: {
        attachments: Array,
        inline: { default: false },
        leftSide: { default: false },
        rightSide: { default: false },
        removable: { default: false },
        include_source: { default: false },
        sortable: { default: false },
        open_in_new_tab: { default: false },
        meeting: { }
    },
    methods: {
        removeItem(attachment) {
            this.$emit("attachment_removed", attachment);
        },
        startSorting() {
            this.$emit('sorting_started');
        },
        endSorting() {
            this.$emit('sorting_ended');
        },
    },
};
</script>